// Copyright 2025, University of Maryland, All Rights Reserved
import { apiClient } from './api-client'
import type { Config } from '@/api/types/config'

export const configApi = {
  getWorkspaceConfig: async (org_id: string, ws_id: string): Promise<Config> => {
    console.log(`🔍 Fetching config for org ${org_id}, workspace ${ws_id}`)
    const response = await apiClient.get<Config>(`/org/${org_id}/ws/${ws_id}/config`)
    console.log('✅ Fetched workspace config:', response.data)
    return response.data
  },

  updateWorkspaceConfig: async (org_id: string, ws_id: string, data: Partial<Config>): Promise<Config> => {
    console.log(`✏️ Updating config for org ${org_id}, workspace ${ws_id}:`, data)
    const response = await apiClient.put<Config>(`/org/${org_id}/ws/${ws_id}/config`, data)
    console.log('✅ Updated workspace config:', response.data)
    return response.data
  }
}